import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: [],
  currentStep: 1,
  selectItem: {},
  selectedUser: {},
  selectedGroups: [],
  copySelectedGroups: [],
  groupData: {
    Groups: [],
  },
  copyGroupData: {
    Groups: [],
  },
  allDataSelected: {},
};

export const searchSlice = createSlice({
  name: "searchSlice",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    setSelectItem: (state, action) => {
      state.selectItem = action.payload;
    },
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
    setSelectedGroups: (state, action) => {
      state.selectedGroups = action.payload;
    },
    setCopySelectedGroups: (state, action) => {
      state.copySelectedGroups = action.payload;
    },
    setGroupData: (state, action) => {
      state.groupData = action.payload;
    },
    setCopyGroupData: (state, action) => {
      state.copyGroupData = action.payload;
    },
    addToGroup: (state, action) => {
      const hasData = state.groupData.Groups.some(
        (e) => e.idTestGroup === action.payload.group.idTestGroup
      );
      if (hasData) {
        let i = state.groupData.Groups.findIndex(
          (e) => e.idTestGroup === action.payload.group.idTestGroup
        );
        let index = state.groupData.Groups[i].items.findIndex(
          (x) => x.idTestGroupItem === action.payload.value
        );
        if (index !== -1) {
          state.groupData.Groups[i].items.splice(index, 1);
          if (state.groupData.Groups[i].items.length === 0) {
            state.groupData.Groups.splice(i, 1);
          }

          state.copyGroupData = state.groupData;
          return;
        }

        state.groupData.Groups.find(
          (x) => x.idTestGroup === action.payload.group.idTestGroup
        ).items.push({
          name: action.payload.group.items.find(
            (x) => x.idTestGroupItem === action.payload.value
          ).name,
          idTestGroupItem: action.payload.value,
          code: action.payload.group.items.find(
            (x) => x.idTestGroupItem === action.payload.value
          ).code,
        });
      } else {
        state.groupData.Groups.push({
          idTestGroup: action.payload.group.idTestGroup,
          items: [
            {
              name: action.payload.group.items.find(
                (x) => x.idTestGroupItem === action.payload.value
              ).name,
              idTestGroupItem: action.payload.value,
              code: action.payload.group.items.find(
                (x) => x.idTestGroupItem === action.payload.value
              ).code,
            },
          ],
        });
      }
      state.copyGroupData = { ...state.groupData };
      // state.groupData.Groups.push(action.payload);
    },
    clearGroup: (state) => {
      state.groupData.Groups = [];
      state.copyGroupData.Groups = [];
      state.selectedGroups = [];
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setAllDataSelected: (state, action) => {
      state.allDataSelected = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSearch,
  setSelectItem,
  setGroupData,
  setSelectedUser,
  setSelectedGroups,
  setCopySelectedGroups,
  setCopyGroupData,
  addToGroup,
  setCurrentStep,
  clearGroup,
  setAllDataSelected,
} = searchSlice.actions;

export default searchSlice.reducer;
